module.exports = __webpack_public_path__ + "img/tree-03-a-trunk.7195e358.png";